export const log = (type: any) => console.log.bind(console, type);
